import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useEffect } from 'react';

const FaqsStatic = () => {


    useEffect(() => {
            window.scrollTo(0, 0);
        }, []);
    
    return (
        <Box sx={{
            p: '1rem',
            backgroundColor: '#DCF1F0'
        }}>
            <Box sx={{
                maxWidth: '85rem',
                margin: 'auto'
            }}>
                <Box sx={(theme) => ({
                    display: 'flex',
                    padding: 0,
                    alignItems: 'center',
                    justifyContent: 'center',
                    [`${theme.breakpoints.down('sm')}`]: {
                        flexDirection: 'column-reverse'
                    }
                })}>
                    <Typography sx={{ flexBasis: '70%' }}>
                        <>
                            <Typography variant='h5' sx={(theme) => ({
                                color: 'text.secondary',
                                fontSize: '2rem',
                                fontWeight: 'bold'
                            })}>
                                FAQ - Prescriptions
                            </Typography>
                            <Typography>
                                <p> 1. How do medication prescriptions work?</p>
                                <ul>
                                    <p>Once a clinician issues a prescription, they will email it directly to you via a secure link. You can then take this prescription to a local community pharmacy of your choice at your convenience. Please note that the cost of the medication itself is paid directly to the dispensing pharmacy. We recommend / we will share that you keep your registered NHS GP informed of any medication prescribed by us. If you experience any adverse reactions or side effects to medication prescribed by us, you must seek medical advice promptly from either the dispensing pharmacy, your supervising consultant, your NHS GP or 111 or A&E as appropriate.</p>
                                </ul>
                                <p> 2. How do repeat prescriptions work?</p>
                                <ul>
                                    <p>You will need to contact your MediRadar online GP or specialist in order to obtain any repeat prescriptions directly from them as your clinician. MediRadar ourselves do not issue or prescribe medications and this is done by clinicians as independent practitioners working through our platform.</p>
                                </ul>
                                <p> 3. What to do in an emergency?</p>
                                <ul>
                                    <p>In the event of an emergency you will need to attend your nearest emergency department if you feel seriously unwell. MediRadar clinicians are not able to provide consultations for urgent or emergency presentations (examples of these include but are not limited to – sudden onset chest pain, severe sudden onset abdominal pain, new sudden onset slurred speech, loss of power in limbs, acute injury or trauma).</p>
                                </ul>
                            </Typography>
                        </>
                    </Typography>

                </Box>
            </Box>

        </Box>
    );
};

export default FaqsStatic;